var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLongShortIndex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BCtrend",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Funding-Rate",
    transform: "translate(-40.000000, -510.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(40.000000, 510.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.987654306,-8.8817842e-15 C0.444444421,-8.8817842e-15 -1.38200562e-12,0.444444444 -1.38200562e-12,0.987654329 L-1.38200562e-12,18.271605 C-1.38200562e-12,18.8148148 0.444444444,19.2592593 0.987654306,19.2592593 L18.2716049,19.2592593 C18.8148148,19.2592593 19.262334,18.9368299 19.262334,18.39362 C19.262334,17.8504101 18.8148148,17.4829937 18.2716049,17.4829937 L1.76012116,17.4829937 L1.76012116,0.987654329 C1.76012116,0.444444444 1.40104754,-8.8817842e-15 0.857837659,-8.8817842e-15",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64702756,7.54213772 C7.06168841,7.38073716 7.01481559,7.58006645 6.767902,7.97512818 L3.23831866,13.9953952 C2.94202236,14.4892223 3.05110857,14.9793104 3.49555304,15.226224 C3.69308389,15.3249894 3.80246914,15.308642 3.95061727,15.308642 C4.29629627,15.308642 4.6419753,15.1111111 4.79012345,14.8148148 L7.85185185,9.58024692 L11.5555556,10.8148148 C12,10.962963 12.3087325,11.0026456 12.5556461,10.6075839 L15.5061728,5.58024692 L16.4444444,6.07407407 C17.037037,6.41975308 17.7777778,5.97530863 17.728395,5.33333333 L17.4814815,1.48148148 C17.4320988,0.839506181 16.691358,0.444444444 16.1481481,0.740740741 L12.7407407,2.61728396 C12.1481481,2.91358025 12.1975309,3.75308644 12.8395062,4.09876544 L13.979205,4.74705168 L11.3927726,9.02433016 L7.64702756,7.54213772 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongShortIndex);
export default __webpack_public_path__ + "static/media/long-short-index.7703753ef39567340b9bf247d230526f.svg";
export { ForwardRef as ReactComponent };